import { useState } from "react";
import { CameraOutlined } from "@ant-design/icons";

/**
 * A capture's picture, or a quiet placeholder when there is no link or it did not load.
 * A failed load reports once (fresh links are fetched) and tries again when the link changes.
 */
export default function Shot({ url, alt = "", onError, className = "" }) {
  const [failed, setFailed] = useState(null);
  if (!url || failed === url) {
    return (
      <span className={`proctoring-review__shot-img proctoring-review__shot-img--empty ${className}`} role="img" aria-label={alt || "No image"}>
        <CameraOutlined />
      </span>
    );
  }
  return (
    <img
      className={`proctoring-review__shot-img ${className}`}
      src={url}
      alt={alt}
      loading="lazy"
      onError={() => {
        setFailed(url);
        if (onError) onError();
      }}
    />
  );
}
